import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function Ellipsis({ size = '2x' }) {
	return <FontAwesomeIcon icon="ellipsis-h" className="icon-muted" size={size}/>
}
Ellipsis.propTypes = {
	size: PropTypes.string
}
